module.exports = __webpack_public_path__ + "static/img/bzzx-bg.072ce65.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/bzzx-bg.png
// module id = YeX2
// module chunks = 96